import s from "./contacts.module.css";
import Breadcrumbs from "../../assets/Components/breadcrumbs/breadcrumbs";
import map from "../../img/contacts/map.svg";
import phone from "../../img/contacts/phone.svg";
import time from "../../img/contacts/time.svg";
import mail from "../../img/contacts/mail.svg";
import ContactItem from "./ContactItem";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import emailjs from '@emailjs/browser';
import React, {useRef, useState} from "react";
import IsSended from "../../assets/Components/isSended/isSended";
import {showSendMessage} from "../../assets/Tools/showSendMessage/showSendMessage";
import useDocumentTitle from "../../assets/Tools/DocumentTitle/DocumentTitle";


const Contacts = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [isSended, setIsSended] = useState(false);
    const [error, setError] = useState(null);
    useDocumentTitle('Контакты');

    const form = useRef();
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const userID = process.env.REACT_APP_EMAILJS_USER_ID;

    const handleSubmit = (e) => {

        e.preventDefault();
        emailjs.sendForm(serviceId, templateId, form.current, userID).then(() => {
                setName("");
                setEmail("");
                setMessage("");
                showSendMessage(setIsSended);
            }
        ).catch((error) => {
            setError(error.text);
        });
    }


    return (
        <div className={s.contacts}>
            <div className={`${s.contactsContent} content`}>
                <Breadcrumbs/>
                <h3>Связаться с нами</h3>
                <div className={s.contactsMain}>
                    <div className={s.contactsInfo}>
                        <h3>НАШЕ МЕСТОНАХОЖДЕНИЕ</h3>
                        <ContactItem img={map} title="Текстиль" info="Украина, г. Харьков, ул. Пример, 123"/>
                        <ContactItem img={phone} title="Телефон" info="+38011111111"/>
                        <ContactItem img={time} title="Режим работы" info="С Понедельника по Пятницу - с 9:00 до 17:00
                        Выходные дни - с 9:00 до 17:00 в режиме онлайн!"/>
                        <ContactItem img={mail} title="Электронная почта" info="example@gmail.com"/>
                    </div>
                    <div className={s.contactsForm}>
                        <h3>НАПИСАТЬ НАМ</h3>
                        {isSended ? <IsSended message="Сообщение отправлено"/> : null}
                        <form ref={form} onSubmit={(e) => handleSubmit(e)}>
                            <div>
                                <h5>Ваше имя</h5>
                                <input value={name} onChange={(e) => setName(e.target.value)} name="name" type="text"/>
                            </div>
                            <div>
                                <h5>Ваш E-mail</h5>
                                <input value={email} onChange={(e) => setEmail(e.target.value)} name="email"
                                       type="email"/>
                            </div>
                            <div>
                                <h5>Ваш сообщение</h5>
                                <textarea value={message} onChange={(e) => setMessage(e.target.value)} name="message"
                                          placeholder="Ваше сообщение..."/>
                            </div>
                            {error ? <p>{error}</p> : null}
                            <BuyButton>ОТПРАВИТЬ</BuyButton>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contacts;